import { getCountryCode } from "src/utils/meristemContext";
import { isClinicalRoute } from "src/utils/userSegment";
import { registerHandler } from "../handler";
import { MedProductType } from "src/utils/constants";

declare const window: Window & {
  nf0?: any;
};

const MED_PRODUCT_TYPES = {
  [MedProductType.Orals]: "medOrals",
  [MedProductType.GLP1]: "medGLP1",
  [MedProductType.HRT]: "medHRT",
} as const;

let didInit = false;

function getProduct() {
  return isClinicalRoute() ? "med" : "weight";
}

function ensureInit() {
  if (didInit) {
    return;
  }
  if (window.nf0) {
    // For this pixel, tracking properties for a user is another event
    window.nf0("trackStructEvent", "country_code", getCountryCode());
    didInit = true;
  }
}

export default function registerHandlers() {
  registerHandler("init", () => {
    ensureInit();
    window.nf0?.("trackPageView", getProduct(), getCountryCode());
  });

  registerHandler("startMainSurvey", () => {
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "buyflowstarts",
      getProduct(),
      getCountryCode()
    );
  });

  registerHandler("lead", () => {
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "lead",
      getProduct(),
      getCountryCode()
    );
  });

  registerHandler("purchase", () => {
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "signup",
      "weight",
      getCountryCode()
    );
  });

  registerHandler("purchaseIntent", ({ medProductType }) => {
    const productParam = MED_PRODUCT_TYPES[medProductType];
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "signup",
      productParam,
      getCountryCode()
    );
  });

  registerHandler("answerWhereDidYouHear", (response) => {
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "hear_about_us",
      getProduct(),
      ...Object.values(response),
      getCountryCode()
    );
  });
}
